var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"icon-button flex items-center justify-center ml-1",attrs:{"type":"submit","disabled":_vm.disabled},on:{"click":_vm.onClick}},[(!_vm.loading)?_c('fluent-icon',{style:(`color: ${_vm.color}`),attrs:{"icon":"send"}}):_c('spinner',{attrs:{"size":"small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }